import { Params } from "../queries/tickets.queries";

export const cashRegisterQueryKeys = {
  all: ["cash-register"] as const,
  me: () => [...cashRegisterQueryKeys.all, "me"] as const,
  session: () => [...cashRegisterQueryKeys.me(), "session"] as const,
  entries: () => [...cashRegisterQueryKeys.me(), "entries"] as const,
  commands: (id: string) =>
    [...cashRegisterQueryKeys.me(), "commands", id] as const,
  lastCommand: (id: string) =>
    [...cashRegisterQueryKeys.commands(id), "last"] as const,
  cashRegisters: () =>
    [...cashRegisterQueryKeys.me(), "cashRegisters"] as const,
  formQuestions: () =>
    [...cashRegisterQueryKeys.me(), "formQuestions"] as const,
};

export default cashRegisterQueryKeys;
